import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";
import { TID } from "@/lib/testIds";

export default function AboutSection() {
  const { t } = useI18n();
  const bullets = t("about.bullets");

  return (
    <section
      data-testid={TID.about}
      className="relative bg-white py-24 md:py-32"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-5"
          >
            <p className="gc-eyebrow">{t("about.eyebrow")}</p>
            <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight font-[700] text-[color:var(--gc-ink)]">
              {t("about.title")}
            </h2>
            <div className="mt-8 h-px w-24 bg-[color:var(--gc-red)]" />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="lg:col-span-7"
          >
            <p className="text-lg md:text-xl leading-relaxed text-[color:var(--gc-graphite)]">
              {t("about.p1")}
            </p>
            <p className="mt-5 text-base md:text-lg leading-relaxed text-[color:var(--gc-steel)]">
              {t("about.p2")}
            </p>

            <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
              {Array.isArray(bullets) &&
                bullets.map((b, i) => (
                  <li
                    key={i}
                    className="flex items-start gap-3 text-[color:var(--gc-ink)] text-[15px]"
                  >
                    <span className="mt-2 w-2 h-2 bg-[color:var(--gc-red)] shrink-0" />
                    <span>{b}</span>
                  </li>
                ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
